import React, {useEffect, useState} from 'react';
import {verifyTurnstileToken} from '../lib/api';
import TurnstileWidget from './TurnstileWidget';
import styles from '../styles/components/VerificationGate.module.css';

interface VerificationGateProps {
  children: React.ReactNode;
}

const VerificationGate: React.FC<VerificationGateProps> = ({children}) => {
  const [token, setToken] = useState<string | null>(localStorage.getItem('turnstile_token'));
  const [isVerifying, setIsVerifying] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const handleAuthInvalid = () => setToken(null);
    window.addEventListener('auth-invalid', handleAuthInvalid);
    return () => window.removeEventListener('auth-invalid', handleAuthInvalid);
  }, []);

  if (token) {
    // Key on token so children remount (and re-fetch data) after re-verification
    return <React.Fragment key={token}>{children}</React.Fragment>;
  }

  const handleVerify = async (widgetToken: string) => {
    setIsVerifying(true);
    setError(null);
    try {
      const jwtToken = await verifyTurnstileToken(widgetToken);
      localStorage.setItem('turnstile_token', jwtToken);
      setToken(jwtToken);
    } catch {
      setError('Verification failed. Please try again.');
      localStorage.removeItem('turnstile_token');
    } finally {
      setIsVerifying(false);
    }
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.card}>
        <h2 className={styles.title}>Verification Required</h2>
        <p className={styles.subtitle}>Please complete the check below to access this page.</p>
        <TurnstileWidget onVerify={handleVerify} />
        {isVerifying && <p className={styles.verifying}>Verifying...</p>}
        {error && <p className={styles.error}>{error}</p>}
      </div>
    </div>
  );
};

export default VerificationGate;
